import './App.css';
import NavBar from './components/NavBar.tsx';
import { Route, Routes } from 'react-router-dom';
import Disorder from './components/Disorder.tsx';
import Home from './components/Home.tsx'
import Analysis from './components/Analysis.tsx'
import Sources from './components/Sources.tsx';
import MintDBFooter from './components/MintDBFooter.tsx'
import Team from './components/Team.tsx'
import FAQ from './components/FAQ.tsx'
import SQLGuide from './components/SQLGuide.tsx'
import InvestigationalTargets from './components/InvestigationalTargets.tsx'
import Login from './components/Login.tsx'
import Register from './components/Register.tsx'
import ForgotPassword from './components/ForgotPassword.tsx'
import ResetPassword from './components/ResetPassword.tsx'


function App() {

  return (<>
    <NavBar />

    <Routes>
      <Route path="/" element={<Home></Home>}></Route>
      <Route path='/disorders/:id' element={<Disorder></Disorder>}></Route>
      <Route path="/analysis" element={<Analysis />}></Route>
      {/* <Route path="/binding-sites" element={<BindingSiteAnalysis></BindingSiteAnalysis>}></Route> */}
      <Route path="/investigational" element={<InvestigationalTargets />}></Route>
      <Route path="/sources" element={<Sources></Sources>}></Route>
      <Route path="/team" element={<Team></Team>}></Route>
      <Route path="/faq" element={<FAQ></FAQ>}></Route>
      <Route path="/sql-guide" element={<SQLGuide></SQLGuide>}></Route>
      <Route path="/login" element={<Login></Login>}></Route>
      <Route path="/register" element={<Register></Register>}></Route>
      <Route path="/forgot-password" element={<ForgotPassword></ForgotPassword>}></Route>
      <Route path="/reset-password" element={<ResetPassword></ResetPassword>}></Route>
    </Routes>


    <MintDBFooter/>
  </>)
}


export default App;